export default "__VITE_ASSET__DaLz_Rey__"